import React, { Component, PureComponent } from "react";
import {
  Button,
  Input,
  Form,
  FormGroup,
  CustomInput,
  Badge
} from "reactstrap";

export default class TagsList extends React.Component {
  constructor({ defaultTagIds }) {
    super();
    this.updateSelection = this.updateSelection.bind(this);
  }

  updateSelection(event) {
    let tagIds = this.props.filterByTagIds.slice();
    if (event.target.checked) {
      tagIds.push(parseInt(event.target.value, 10));
    } else {
      const indexOf = tagIds.indexOf(parseInt(event.target.value, 10));
      tagIds.splice(indexOf, 1);
    }
    this.props.tagsSelectionChanged(tagIds);
  }

  render() {
    return (
      <Form>
        <table>
          <tbody>
            {this.props.tags.map(tag => (
              <tr key={tag.tagId}>
                <td style={{ whiteSpace: "nowrap" }}>
                  <CheckboxWithTooltip
                    checked={
                      this.props.filterByTagIds.indexOf(tag.tagId) !== -1
                    }
                    tag={tag}
                    onChange={this.updateSelection}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Form>
    );
  }
}

class CheckboxWithTooltip extends React.Component {
  constructor() {
    super();
    this.showTooltip = this.showTooltip.bind(this);
  }

  showTooltip(e, tag) {
    const content =
      tag.name +
      "<br/>" +
      tag.description +
      "<br/> عدد الأحداث : " +
      tag.totalEvents;

      let {left, top} = e.target.getBoundingClientRect();
      window.showTooltip(content, left - 200, top);
  }

  render() {
    return (
      <span
      >
        <input
          type="checkbox"
          id={"tag" + this.props.tag.tagId}
          value={this.props.tag.tagId}
          onChange={this.props.onChange}
          checked={this.props.checked}
          label={this.props.tag.name}
        />&nbsp;
        <label
        onMouseEnter={e => this.showTooltip(e, this.props.tag)}
        onMouseLeave={() => window.hideTooltip(false)}

        for={"tag" + this.props.tag.tagId}>{this.props.tag.name}</label>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/TagsList.js